// src/pages/HomePage.jsx
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import { getRoles } from '../functions/authUtils';
import { useToast } from '../components/ToastProvider';
import '../styles/HomeDashboard.css';

import { ReactComponent as IconChat } from "../assets/icons/icon-chat.svg";
import { ReactComponent as IconFile } from "../assets/icons/icon-file.svg";
import { ReactComponent as IconShield } from "../assets/icons/icon-shield.svg";

export default function HomePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { showError } = useToast();

  const roles = getRoles() ?? [];

  /** Tarjetas visibles según rol */
  const tiles = [
    {
        title: 'Chat GA4',
        text: 'Chat conectado a MCP de Google Analytics.',
        Icon: IconChat,
        to: '/chat',
        role: 'chatbot'
    },
    // {
    //     title: 'Gestión de Clientes',
    //     text: 'Crea y edita clientes.',
    //     icon: 'bi-people',
    //     to: '/clientes',
    //     role: 'surveys'
    // },
    // {
    //     title: 'Planificaciones',
    //     text: 'Planificaciones de las campañas',
    //     icon: 'bi-compass',
    //     to: '/guia-turistica',
    //     role: 'planifications'
    // },
    // {
    //     title: 'Analíticas',
    //     text: 'Análisis de las campañas',
    //     icon: 'bi-compass',
    //     to: '/guia-turistica',
    //     role: 'analysis'
    // },
    {
        title: 'Panel Administración',
        text: 'Usuarios, roles y configuraciones.',
        Icon: IconShield,
        to: '/admin/users',
        role: 'admin'
    },
    {
        title: 'Manual de usuario',
        text: '(PDF)',
        Icon: IconFile,
        to: '/manual',
        role: 'all'
    }
  ];

  const visibles = tiles.filter(t =>
    roles.includes('admin') || t.role === 'all' || roles.includes(t.role)
  );

  /* mensaje “noAccess” */
  useEffect(() => {
    if (new URLSearchParams(location.search).get('error') === 'noAccess') {
      showError('No tienes acceso a esa página.');
    }
  }, [location, showError]);

  return (
    <section className="container py-4">
      <h1 className="title mb-4">Panel principal</h1>

      <Row xs={1} md={2} lg={3} className="g-4">
        {visibles.map(({ title, text, Icon, to }) => (
          <Col key={title}>
            <button className="dash-card neutral" onClick={() => navigate(to)}>
              <div className="dash-icon-wrapper neutral">
                {Icon ? (
                  <Icon className="dash-icon" aria-hidden="true" />
                ) : (
                  <i className={`bi bi-question-circle dash-icon`} />
                )}
              </div>
              <div className="dash-content">
                <h3>{title}</h3>
                <p>{text}</p>
              </div>
            </button>
          </Col>
        ))}
      </Row>
    </section>
  );
}
